export default __webpack_public_path__ + "static/media/ucsd-profile.8691f84f.jpg";